'use strict';

const _=require('pulsar-utils/dist-es6/_');
const AngularHelpers=require('../../../../dist-es6/client/angularCommon/angularHelpers');
const LoadUrlMatcherTypes=require('../../../../dist-es6/client/services/paramSyncService').LoadUrlMatcherTypes;let

PersonalScheduleConfig=class PersonalScheduleConfig{
static get $inject(){return['$stateProvider','$urlMatcherFactoryProvider']}

constructor($stateProvider,$urlMatcherFactoryProvider){
LoadUrlMatcherTypes($urlMatcherFactoryProvider);
let feature=AngularHelpers.generateAuthenticatedFeatureConfig('personalSchedule',{
url:'/personalSchedule?{id:GuidString}&{employeeId:string}&{interval:TimeInterval}&{timezone:Timezone}&{personalScheduleTabSelection:int}',
reloadOnSearch:!1,
views:{
"breadcrumbs@":{
templateUrl:`/templates/layout/breadcrumbs`}}});



$stateProvider.state(feature.fullName,feature.config);
}};


module.exports=PersonalScheduleConfig;
//# sourceMappingURL=personalScheduleConfig.js.map
